import React        from 'react';
import _ from 'lodash';

export default class SVGChart extends React.Component {
    constructor(props,context) {
        super(props,context);
        this.props=props;
        this.context=context;
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this._handleMouseMove = _.throttle(this.handleMouseMove,100).bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.state = { mouseCoords: [null,null] };    
    }
    componentDidMount() {
        let self = this;        
        d3.select(this.refs.mousetracker).on('mousemove',function() { self._handleMouseMove(d3.mouse(this)) })
            .on('mouseleave', this.handleMouseLeave);//this._handleMouseMove);
        
    }
    handleMouseMove(coords) {
        this.setState({mouseCoords: coords});
    }
    handleMouseLeave(coords) {
        setTimeout(() => this.setState({mouseCoords: [null,null]}),120);
    }
    getChildContext() {
        let retobj = {
            mouseX: this.state.mouseCoords[0],
            mouseY: this.state.mouseCoords[1]
        };
        return retobj;
	}

    render() {
        
        const childrenWithProps = React.Children.map(this.props.children.filter((el)=>el!=null), (child) => {
            return React.cloneElement(child, Object.assign({},this.props, child.props));
        });

        return <div ref="mousetracker">
            {childrenWithProps}
        </div>
        
    }
}

SVGChart.childContextTypes = {
	mouseX: React.PropTypes.number,
    mouseY: React.PropTypes.number
}


// WEBPACK FOOTER //
// ./src/js/components/charting/MouseTracker/MouseTracker.jsx